"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAGIC_SCALING_NUMBER = exports.pdfTheme = exports.DEFAULT_BACKGROUND = exports.DEFAULT_COMPONENT_SPACING = void 0;
const theme_1 = require("../../components/theme");
exports.DEFAULT_COMPONENT_SPACING = 4;
exports.DEFAULT_BACKGROUND = '#f0f0f0';
const pageSize = 'LETTER';
const [pageWidth, pageHeight] = [612.0, 792.0];
exports.pdfTheme = {
    background: {
        dark: theme_1.DefaultTheme.background.darkGrey,
        medium: theme_1.DefaultTheme.background.mediumGrey,
        light: theme_1.DefaultTheme.background.fadedGrey,
        default: exports.DEFAULT_BACKGROUND,
    },
    font: {
        color: {
            dark: theme_1.DefaultTheme.font.color.primary,
            light: theme_1.DefaultTheme.font.color.insight,
        },
        size: {
            default: 12,
            small: 10,
            large: 16,
        },
    },
    spacing: {
        large: 8,
        default: exports.DEFAULT_COMPONENT_SPACING,
        small: 2,
    },
    page: {
        size: pageSize,
        width: pageWidth,
        height: pageHeight,
    },
};
// line height = font times 1.18 because ¯\_(ツ)_/¯
exports.MAGIC_SCALING_NUMBER = 1.18;
//# sourceMappingURL=pdfTheme.js.map